import {
  profileLogout,
  directToURl,
  isRoleCashier
} from "../utils";
import {
  FORCE_LOGOUT,
  USER_INACTIVITY,
  EXPIRY_TIME,
  orderManagerNotificationConfig,
} from "../constants";

const DURATION_IN_MINS = 15;
const USER_ACTIVITIES = [
  "load",
  "mousemove",
  "mousedown",
  "mouseup",
  "keypress",
  "DOMMouseScroll",
  "mousewheel",
  "MSPointerMove",
  "click",
  "scroll",
  "touchstart",
  "touchmove",
  "touchend",
];

export function sessionStart() {
  setExpiry();
  USER_ACTIVITIES.forEach((eventName) => {
    window.addEventListener(eventName, setExpiry);
  });
}

export function sessionPause(duration) {
  if (!duration) return;
  isPaused = true;
  setTimeout(() => {
    isPaused = false;
  }, duration);
}

export function sessionEnd() {
  clearInterval(interval);
  USER_ACTIVITIES.forEach((eventName) => {
    window.removeEventListener(eventName, setExpiry);
  });
  localStorage.removeItem(EXPIRY_TIME);
}

function setExpiry() {
  const expireAt = Date.now() + DURATION_IN_MINS * 60000;
  localStorage.setItem(EXPIRY_TIME, expireAt);
}

var interval, isPaused;

export function isSessionTimedOut() {
  //remove session timeout for local dev and cashier
  if (process.env.TROY_NO_CHECK_IDLE_TIMEOUT === "true" || isRoleCashier()) {
    return;
  }
  const expireAt = localStorage.getItem(EXPIRY_TIME);
  const now = Date.now();
  if (expireAt && (now > expireAt)) {
    return true;
  }
  return false;
}

export function checkIdleTimeout(history, trackEvent) {
  //remove idle timeout for local dev and cashier
  if (process.env.TROY_NO_CHECK_IDLE_TIMEOUT === "true" || isRoleCashier()) {
    return;
  }
  interval = setInterval(() => {
    const expireAt = localStorage.getItem(EXPIRY_TIME);
    const now = Date.now();
    if (expireAt && now > expireAt && !isPaused){
      forceLogout(history, trackEvent);
    }
  }, 1000);
}

export function forceLogout(history, trackEvent) {
  sessionEnd();
  trackEvent && trackEvent(FORCE_LOGOUT, USER_INACTIVITY, null);
  directToURl(history, profileLogout);
}
